import React, {
  useEffect,
  useState,
} from "react";

import jwt_decode from "jwt-decode";

import {
  FaFileInvoiceDollar,
} from "react-icons/fa";

import AddViaje from "../components/AddViaje";
import TableViajes from "../components/TableViajes";
import Footer from "../components/Footer";

import "../css/admin.css";
import "../css/rendiciones.css";

const Viajes = () => {
  const [usuario, setUsuario] =
    useState({});

  const [show, setShow] =
    useState(false);

  const token =
    localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode =
          jwt_decode(token);

        setUsuario(
          token_decode.usuario
        );
      } catch (e) {
        console.error(
          "❌ Error al decodificar token:",
          e
        );

        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <main className="ren2-page">
        {token ? (
          usuario?.role ===
          "ADMIN_ROLE" ? (
            <>
              <section className="ren2-header">
                <div className="ren2-header-icon">
                  <FaFileInvoiceDollar />
                </div>

                <div className="ren2-header-text">
                  <span>
                    LIQUIDACIONES
                  </span>

                  <h1>
                    Gestión de Rendiciones
                  </h1>

                  <p>
                    Seguimiento de viajes,
                    kilómetros, combustible,
                    viáticos, adelantos, gastos
                    y liquidación final.
                  </p>
                </div>
              </section>

              <div className="ren2-actions">
                <AddViaje
                  setShow={setShow}
                  show={show}
                />
              </div>

              {!show && (
                <TableViajes />
              )}
            </>
          ) : (
            <div
              className="alert alert-info"
              role="alert"
            >
              Lo sentimos, pero no tiene
              permisos para acceder a este
              contenido.
            </div>
          )
        ) : (
          <div
            className="alert alert-danger"
            role="alert"
          >
            No se encuentra logueado en la
            plataforma.
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Viajes;